export const NiceBlue = '#0f72bb';
export const Bluish = '#2083cb';
export const DarkSkyBlue = '#2daae1';
export const SunYellow = '#ffe431';
export const Black = '#222222';
export const GreyishBrown = '#444444';
export const WarmGrey = '#999999';
export const BrownishGrey = '#666666';
export const CoolGrey = '#a7b2ba';
export const White = '#d8d8d8';
export const DarkishBlue = '#004889';
export const WhiteThree = '#f5f5f5';
export const WhiteFour = '#ffffff';
export const WhiteTwo = '#eaeaea';
export const Red = '#cd4144';

export const HeaderMask = 'rgba(117, 135, 149, 0.3)';



// WEBPACK FOOTER //
// ./src/styles/Colours.js